import type React from 'react'
import { useGetPostprocessingDataSelector } from '../../../../../Flux/Selector/index.js'
import type { IOrder } from '../../../../../Model/index.js'
import { getResultUnitLabel, isEdnaProcessingType, isOtuProcessingType } from '../../../../../Util/processingType.ts'
import { useDispatch } from 'react-redux'
import Actions from '../../../../../Flux/index.js'
import { orderSlice } from '../../../../../Flux/Slice/Order/OrderSlice.js'

interface PostprocessingTabProps {
  order: IOrder
  onClose: () => void
}

export const PostprocessingTab = (props: PostprocessingTabProps) => {
  const postprocessingData = useGetPostprocessingDataSelector()
  const dispatch = useDispatch()

  return (
    <>
      <input type="radio" name="my_tabs_1" role="tab" className="tab" aria-label="Postprocessing" />
      <div role="tabpanel" className="tab-content p-10">
        <div className="overflow-x-auto overflow-y-auto">
          <table className="table table-zebra w-full">
            <thead>
              <tr>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Run Id</td>
                <td>{postprocessingData?.dagRunId ?? 'N/A'}</td>
              </tr>
              <tr>
                <td>Dereplicate Final Sequences</td>
                <td>{postprocessingData?.dereplicateFinalSequences ?? 'N/A'}</td>
              </tr>
              <tr>
                <td>Chimera Count</td>
                <td>{postprocessingData?.chimeraCount ?? 'N/A'}</td>
              </tr>
              <tr>
                <td>Abundance Chimera Count</td>
                <td>{postprocessingData?.abundanceChimeraCount ?? 'N/A'}</td>
              </tr>
              <tr>
                <td>Abundance Non Chimera Count</td>
                <td>{postprocessingData?.abundanceNonChimeraCount ?? 'N/A'}</td>
              </tr>
            </tbody>
          </table>

          {(postprocessingData?.negativeControlFiltering?.length ?? 0) > 0 && (
            <table className="table table-zebra w-full">
              <thead>
                <tr>
                  <th>{getResultUnitLabel(props.order.processingType)} ID</th>
                  <th>Negative Control Filtering Count</th>
                </tr>
              </thead>
              <tbody>
                {postprocessingData?.negativeControlFiltering?.map((entry) => (
                  <tr key={entry.id}>
                    <td>{entry.otuId}</td>
                    <td>{entry.maxNeg}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

        <div className="modal-action">
          {props.order.orderDone && isOtuProcessingType(props.order.processingType) && (
            <button className="btn btn-outline" onClick={() => window.open(`/order/${props.order.id}/print-report`, '_blank')}>
              Printable Preview
            </button>
          )}
          {props.order.orderDone && isEdnaProcessingType(props.order.processingType) && (
            <button
              className="btn btn-outline"
              onClick={() => dispatch(
                Actions[orderSlice.name].downloadOrderArtifactRequest({ orderId: props.order.id, artifact: 'PROCESSING_SUMMARY' })
              )}
            >
              Report Summary
            </button>
          )}
          <button className="btn btn-primary" onClick={props.onClose}>
            Close
          </button>
        </div>
      </div>
    </>
  )
}
